function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_126",
  "data-name": "Grupo 126",
  transform: "translate(-10.641)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-phone-alt",
  "data-name": "Icon awesome-phone-alt",
  d: "M21.335,15.519l-4.8-2.059a1.029,1.029,0,0,0-1.2.3l-2.128,2.6a15.9,15.9,0,0,1-7.6-7.6L8.2,6.628a1.027,1.027,0,0,0,.3-1.2L6.439.623a1.036,1.036,0,0,0-1.18-.6L.8,1.056a1.029,1.029,0,0,0-.8,1,19.9,19.9,0,0,0,19.9,19.9,1.029,1.029,0,0,0,1-.8L21.936,16.7a1.042,1.042,0,0,0-.6-1.184Z",
  transform: "translate(10.641 0)",
  fill: "#ee9236"
}));

var SvgFixoIcon = function SvgFixoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.962,
    height: 21.962,
    viewBox: "0 0 21.962 21.962",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFixoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fixo_icon.9994c5d5.svg";
export { ForwardRef as ReactComponent };